import {
  Avatar,
  Button,
  CssBaseline,
  TextField,
  FormControlLabel,
  Checkbox,
  Grid,
  Box,
  Typography,
  Container,
  Modal,
  InputAdornment,
  IconButton,
  Fade
} from '@mui/material';
import React, { useState, useEffect } from 'react';
import {
  LockOutlined as LockOutlinedIcon,
  Visibility,
  VisibilityOff,
  EmailOutlined,
  ArrowForward
} from '@mui/icons-material';
import { Link } from 'react-router-dom';
import ReactLoading from 'react-loading';
import { primarycolor } from '../Utils/colors';
import { setLoggedIn, setUser } from '../../store/user';
import { useDispatch, useSelector } from 'react-redux';
import { Erroralert, Successalert } from '../Components/popups';
import fetch from '../Utils/fetch';
import SignUp from './register';



let color = "white";
let type = "spokes";

function Copyright({ sx, fullName }) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" sx={sx}>
      {'Copyright © '}
      <Link color="inherit" to="/nav/terms">
        {fullName}   All Rights Reserved.
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}



export default function SignIn({ onsuccesslogin, ondismiss }) {
  const dispatch = useDispatch();
  const webSettings = useSelector((state) => state.webSettings.data);
  const fullName = webSettings.FULL_NAME;
  const firstname = fullName?.split(' ')[0];

  const [checked, setChecked] = React.useState(true);
  const [progress, setprogress] = useState(false);
  const [error, seterror] = useState('');
  const [success, setsuccess] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const [showlogin, setshowlogin] = useState(true);


  const handleSubmit = (event) => {
    seterror(null)
    setprogress(true)
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const email = data.get('email')
    const password = data.get('password')
    if (!email || !password) {
      seterror("fill all fields")
      setprogress(false)
    } else {
      seterror(null)
      fetch.get('getLogin', {
        username: email,
        password: password
      }).then(response => {
        setprogress(false)
        if (!response.error) {
          let data = response.data;
          if (data.token) {
            setsuccess('Login successful!')
            dispatch(setUser(data));
            dispatch(setLoggedIn(true));
            setTimeout(() => {
              onsuccesslogin()
            }, 3000);

          } else {
            seterror("Invalid Credentials");
          }
        } else {
          setprogress(false)
          seterror(response.data.message)
        }
        // 
      }).catch(error => {
        console.log("error", error)
        setprogress(false)
        seterror(error || "Sorry an error occurred,try again later");
      });
    }
  };




  const handleChange = (event) => {
    setChecked(event.target.checked);
  };




  return (
    <Modal
      open={true}
      onClose={() => ondismiss()}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Container component="main" maxWidth="xs" style={{ backgroundColor: "white", borderRadius: 20 }}>
        <CssBaseline />
        {error?.length > 0 && <Erroralert onClose={() => seterror()} message={error} />}
        {success?.length > 0 && <Successalert onClose={() => setsuccess()} message={success} />}
        {showlogin ?
          <Fade in={true} timeout={800}>
            <Box
              sx={{
                marginTop: 8,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <Avatar sx={{ m: 1, bgcolor: primarycolor, width: 44, height: 44, mb: 1 }}>
                <LockOutlinedIcon fontSize="medium" />
              </Avatar>
              <Typography component="h1" variant="h5" sx={{ fontWeight: 700, mb: 0.5 }}>
                Welcome Back
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 3, textAlign: 'center' }}>
                Sign in to continue shopping.
              </Typography>
              <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1, width: '100%' }}>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="email"
                  label="Email Address"
                  name="email"
                  autoComplete="email"
                  autoFocus
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <EmailOutlined color="action" />
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  autoComplete="current-password"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LockOutlinedIcon color="action" />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => setShowPassword(!showPassword)}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <FormControlLabel
                  control={<Checkbox onChange={handleChange} value="remember" color="primary" />}
                  label={<Typography variant="body2">Remember me</Typography>}
                />
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  disabled={progress}
                  sx={{
                    mt: 3,
                    mb: 2,
                    py: 1.2,
                    borderRadius: 2,
                    fontWeight: 600,
                    textTransform: 'none',
                    fontSize: '1rem',
                    boxShadow: `0 4px 12px ${primarycolor}40`,
                    '&:hover': {
                      boxShadow: `0 6px 16px ${primarycolor}60`,
                    }
                  }}
                >
                  {progress ? (
                    <ReactLoading type={type} color={color} height={24} width={24} />
                  ) : (
                    <>
                      Sign In <ArrowForward sx={{ ml: 1, fontSize: 20 }} />
                    </>
                  )}
                </Button>
                <Grid container justifyContent="center">
                  <Grid item>
                    <Link onClick={() => setshowlogin(false)} to="" style={{ color: primarycolor, fontSize: 14, textDecoration: 'none', fontWeight: 500 }} variant="body2">
                      Don't have an account? Sign up
                    </Link>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Fade> :
          <SignUp
            successsignup={() => {
              onsuccesslogin()
            }}
            cancelsignup={() => {
              setshowlogin(true)
            }}
          />
        }
        <Copyright sx={{ mt: 8, mb: 4 }} fullName={fullName} />
      </Container>
    </Modal>

  );
}